import { ChangeEvent, useCallback, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import CommonInput from "../../../components/common/form copy/input/CommonInput";
import { signin } from "../../../apis/authApi";
import useUiuxStore from "../../../store/useUiuxStore";
import { FindAccountModal } from "../../../components/auth/FindAccountModal";
import useUserStore from "../../../store/useUserStore";

const SigninContainer = () => {

	const navigate = useNavigate();

	const { findAccountModalVisible, setFindAccountModalVisible } = useUiuxStore();

	const [inputData, setInputData] = useState({
		id: '',
		pw: '',
	});

	const idRef = useRef<HTMLInputElement>(null);
	const pwRef = useRef<HTMLInputElement>(null);

	const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
		const { name, value } = e.target;
		setInputData(prev => ({ ...prev, [name]: value }));
	};

	const handleSigninClick = useCallback(async () => {
		const { id, pw } = inputData;

		const response = await signin(id, pw);
		console.log(response);
		if (response?.data?.successFlag) {
			const { accessToken, refreshToken } = response.data.data;
			localStorage.setItem('access-token', accessToken);
			localStorage.setItem('refresh-token', refreshToken);
			navigate('/');
		}

	}, [inputData])

	const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
		console.log('Key pressed:', e.key, 'name:', e.currentTarget.name);
		if (e.key === 'Enter' && e.currentTarget.name === 'id') 		pwRef.current?.focus();
		else if (e.key === 'Enter' && e.currentTarget.name === 'pw')	handleSigninClick();
	}

  return <div 
    className="w-full h-full flex flex-col justify-center items-center p-4"
    style={{
      backgroundImage: 'url(/images/background/backGroundImage.jpg)',
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat'
    }}
  >
    {/* 컨테이너 크기 축소 */}
    <div className="w-full max-w-[clamp(280px,85vw,360px)] min-h-[clamp(380px,65vh,480px)] flex flex-col bg-blue-darkest items-center border-x-[clamp(4px,1.5vw,8px)] border-y-[clamp(4px,1.5vw,8px)] border-blue-darkest px-[clamp(6px,1.5vw,12px)] rounded-[clamp(10px,2.5vw,15px)]">
      {/* padding과 gap 축소 */}
      <div className="w-full h-full flex flex-col gap-[clamp(3px,1vw,6px)] bg-white rounded-[clamp(10px,2.5vw,15px)] py-[clamp(10px,2vw,15px)] px-[clamp(6px,1.5vw,8px)]">

        {/* 로고영역 - 크기와 간격 축소 */}
        <div className="flex flex-row items-center gap-[clamp(6px,1.5vw,10px)] mt-[clamp(5px,1vw,8px)]">
          <img src="/images/logo/IMAGE.jpg" className="h-[clamp(32px,6vw,45px)] object-contain" alt="로고" />
          <p className="text-blue-800 text-[clamp(16px,4vw,24px)] font-bold truncate">
            {process.env.REACT_APP_DEFAULT_COMPANY_NAME || "라온정보랩스"}
          </p>
        </div>

        {/* 타이틀영역 - 간격과 텍스트 크기 축소 */}
        <div className="w-full flex flex-col gap-[1px] mt-[clamp(5px,1vw,8px)]">
          <p className="text-left text-[clamp(12px,2.5vw,15px)] text-gray-700 font-bold">
            Welcome To
          </p>
          <p className="text-center text-[clamp(18px,4.5vw,26px)] text-blue-800 font-bold">
            Raonzena MES Ver 1.0
          </p>
        </div>

        {/* id,pw 영역 - 간격 축소 */}
        <div className="w-full flex flex-col justify-center items-start gap-[clamp(4px,1vw,8px)] mt-[clamp(8px,2vw,12px)]">
          <p className="text-[clamp(14px,3vw,18px)] text-gray-800 font-semibold text-left">
            아이디
          </p>
          <CommonInput className="w-full mb-[clamp(10px,2vw,15px)]" 
			value={inputData.id} name="id" ref={idRef}
			onChange={handleChange} 
			onKeyDown={handleKeyDown} 
			placeholder={"아이디"} 
		/>
          <p className="text-[clamp(14px,3vw,18px)] text-gray-800 font-semibold text-left">
            비밀번호
          </p>
          <CommonInput className="w-full"
			value={inputData.pw} name="pw" type="password" ref={pwRef}
			onChange={handleChange}
			onKeyDown={handleKeyDown} 
			placeholder={"비밀번호"}
		/>
        </div>

        {/* 로그인 버튼 — PDA 터치·가독성 */}
        <div className="w-full flex flex-col justify-start items-center gap-[clamp(6px,1.2vw,8px)] mt-[clamp(10px,2vw,15px)]">
          <button
            type="button"
            className="text-white w-full min-h-[clamp(52px,12vw,60px)] rounded-[clamp(8px,2vw,12px)] bg-blue-darkest text-[clamp(16px,3.8vw,22px)] leading-tight font-semibold py-[clamp(14px,3vw,18px)] px-3 active:opacity-90"
            onClick={handleSigninClick}
          >
            로그인
          </button>

        </div>
      </div>
    </div>
    {findAccountModalVisible && <FindAccountModal />}
  </div>
}

export default SigninContainer;